import cn from 'classnames';
import { useEffect, useState } from 'react';
import useWindowSize from 'core-lib/hooks/useWindowResize';
import { CITY_LIST, USER_CITY } from 'src/modules/newCars/constants/cities';
import { CityType } from 'src/modules/newCars/types';
import { Input, Modal, Typography } from 'ui';
import Cross from 'ui/components/newIcons/Cross';
import Search from 'ui/components/newIcons/Search';
import { Color, TypeScales } from 'ui/primitives';
import BottomGraffiti from '../../../icons/cities/BottomGraffiti.svg';
import s from './SelectCity.module.scss';

export const SelectCity = ({
  show,
  onClose,
  onSelect,
  selectedCity,
  cityList,
}: {
  show: boolean;
  onClose: () => void;
  onSelect: (arg) => void;
  selectedCity: CityType;
  cityList: CityType[];
}) => {
  const [focused, setFocused] = useState(false);
  const [typedValue, setTypedValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const { width, height } = useWindowSize();

  function handleCitySelect(city) {
    localStorage.setItem(USER_CITY, JSON.stringify(city));
    onSelect(city);
    setTypedValue(city);
  }
  useEffect(() => {
    if (typedValue?.length) {
      const filteredList = cityList?.filter((city) => {
        return city?.name?.toLowerCase()?.includes(typedValue?.toLowerCase());
      });
      setSuggestions(filteredList?.sort());
    } else setSuggestions([]);
  }, [typedValue]);

  return (
    <>
      {width > 800 ? (
        <Modal
          show={show}
          isWeb
          head={{
            show: true,
            title: 'Select city',
            onClose: onClose,
          }}
          closeOnClickOutside
          noPadding
          animation={{ type: 'fadeAfter', timeout: 's' }}
          variant="fullScreenPopup"
          rootStyle={{
            zIndex: 10,
          }}
          customeBodyStyle={{
            minWidth: '1000px',
            minHeight: '676px',
          }}
        >
          <div className={s.root}>
            <div className={s.left}>
              <div className={s.top}>
                <Typography label="Select your city" variant={TypeScales.h1} />
                <div className={s.input}>
                  <Input
                    withShadow
                    placeholder="Search city"
                    leftIcon={<Search primaryColor={Color.text_placeholder} />}
                    rightIcon={
                      <button onClick={() => setTypedValue('')}>
                        <Cross primaryColor={Color.text_placeholder} />
                      </button>
                    }
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    onChange={(e) => setTypedValue(e.currentTarget.value)}
                    value={typedValue}
                  />
                </div>
                {!!typedValue?.length && (
                  <div className={s.drop_down}>
                    <div className={s.list}>
                      {!!suggestions?.length ? (
                        suggestions?.map((city) => (
                          <button
                            className={cn(s.city_btn, 'cmn_touchable_area')}
                            onClick={() =>
                              handleCitySelect({
                                name: city?.name,
                                id: city?.id,
                              })
                            }
                            key={city?.name}
                          >
                            {city?.name}
                          </button>
                        ))
                      ) : (
                        <div className={s.no_result}>No results found</div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className={s.bottom}>
                <BottomGraffiti />
              </div>
            </div>
            <div className={s.right}>
              {CITY_LIST?.map((obj) => (
                <button
                  className={cn(s.city_card, {
                    [s.selected]: selectedCity?.name === obj?.name,
                  })}
                  type="button"
                  onClick={() =>
                    handleCitySelect({ name: obj?.name, id: obj?.id })
                  }
                  key={obj?.name}
                >
                  {selectedCity?.name === obj?.name
                    ? obj.selectedIcon
                    : obj.unSelectedIcon}
                  <Typography label={obj?.name} variant={TypeScales.h2} />
                </button>
              ))}
            </div>
          </div>
        </Modal>
      ) : (
        <Modal
          show={show}
          isWeb
          head={{
            show: true,
            title: '',
            onClose: onClose,
          }}
          closeOnClickOutside
          noPadding
          animation={{ type: 'fadeAfter', timeout: 's' }}
          variant="page"
          rootStyle={{
            zIndex: 10,
          }}
        >
          <div className={s.root_mobile}>
            <div className={s.top}>
              <Typography
                label="Select your city"
                variant={TypeScales.h2}
                style={{ marginBottom: '24px' }}
              />
              <div className={s.input}>
                <Input
                  withShadow
                  placeholder="Search city"
                  leftIcon={<Search primaryColor={Color.text_placeholder} />}
                  rightIcon={
                    <button onClick={() => setTypedValue('')}>
                      <Cross primaryColor={Color.text_placeholder} />
                    </button>
                  }
                  onFocus={() => setFocused(true)}
                  onBlur={() => setFocused(false)}
                  onChange={(e) => setTypedValue(e.currentTarget.value)}
                  value={typedValue}
                />
              </div>
              {!!typedValue?.length && (
                <div className={s.drop_down}>
                  <div className={s.list}>
                    {!!suggestions?.length ? (
                      suggestions?.map((city) => (
                        <button
                          className={s.city_btn}
                          onClick={() =>
                            handleCitySelect({ name: city?.name, id: city?.id })
                          }
                          key={city?.name}
                        >
                          {city?.name}
                        </button>
                      ))
                    ) : (
                      <div className={s.no_result}>No results found</div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className={s.bottom}>
              {CITY_LIST?.map((obj) => (
                <button
                  className={cn(s.city_card, 'cmn_touchable_area', {
                    [s.selected]: selectedCity?.name === obj?.name,
                  })}
                  type="button"
                  onClick={() =>
                    handleCitySelect({ name: obj?.name, code: obj?.id })
                  }
                  key={obj?.name}
                >
                  {obj.mobileIcon}
                </button>
              ))}
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
